<template>
  <simple-modal
    :open.sync="openModal"
    :title="title"
    hide-close-button
    no-backdrop-dismiss
    no-esc-dismiss
  >
    <div slot="body" class="q-pa-sm">
      <div class="row">
        {{ message }}
      </div>
    </div>

    <template slot="footer">
      <div class="row justify-end">
        <q-btn
          flat
          no-caps
          color="grey-7"
          class="text-faded q-mr-sm"
          label="Abmelden"
          @click="handleLogout"
        />
        <q-btn
          v-if="forcedLogoutReason === 'mismatch'"
          no-caps
          color="primary"
          class="no-shadow"
          label="Account wechseln"
          :loading="loading"
          :disable="loading"
          @click="switchAccount"
        />
        <q-btn
          v-else
          no-caps
          color="primary"
          class="no-shadow"
          label="Erneut anmelden"
          @click="redirectToOAuthLogin"
        />
      </div>
    </template>
  </simple-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import SimpleModal from '@/components/base/SimpleModal';
import { modal } from '@/plugins/mixins';
import { buildAlzuraOAuthUrl } from '@/components/base/alzuraOAuthUtil.js';

const COPY = {
  session_expired: {
    title: 'Sie wurden ausgeloggt',
    message: 'Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein.',
  },
  mismatch: {
    title: 'Anderes Konto',
    message: 'Sie sind mit einem anderen Account eingeloggt. Bitte loggen Sie sich erneut ein.',
  },
  logged_out: {
    title: 'Sie wurden ausgeloggt',
    message: 'Sie wurden abgemeldet. Bitte loggen Sie sich erneut ein.',
  },
};

export default {
  name: 'ForcedLogoutModal',

  components: {
    SimpleModal,
  },

  mixins: [modal],

  data() {
    return {
      openModal: false,
      loading: false,
    };
  },

  computed: {
    ...mapGetters('auth', ['forcedLogoutReason']),
    title() {
      return this.forcedLogoutReason ? COPY[this.forcedLogoutReason].title : '';
    },
    message() {
      return this.forcedLogoutReason ? COPY[this.forcedLogoutReason].message : '';
    },
  },

  watch: {
    forcedLogoutReason: {
      immediate: true,
      handler(reason) {
        this.openModal = !!reason;
      },
    },
  },

  methods: {
    async switchAccount() {
      this.loading = true;
      try {
        await this.$store.dispatch('auth/loginWithAlzuraOAuthCode');
        this.$q.notify({ message: 'Sie wurden erfolgreich zum anderen Konto gewechselt', type: 'positive', position: 'top-right' });
        this.$emit('account-switched');
        if (this.$route.path !== '/') this.$router.push('/');
      } catch (_error) {
        this.redirectToOAuthLogin();
      } finally {
        this.loading = false;
      }
    },
    redirectToOAuthLogin() {
      const { next } = this.$route.query;
      window.open(buildAlzuraOAuthUrl(next), '_self');
    },
    handleLogout() {
      const next = this.$route.fullPath;
      this.$store.dispatch('auth/logout', { next, reason: this.forcedLogoutReason });
      this.$q.notify({ message: 'Sie wurden erfolgreich ausgeloggt', type: 'info', position: 'top-right' });
    },
  },
};
</script>
